<template>
  <div class="solution-item">
    <div class="content">
      <slot name="icon"></slot>
      <div class="title">{{ title }}</div>
    </div>
    <div class="sub-title">{{ subTitle }}</div>
    <div class="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    subTitle: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.content {
  text-align: left;
  display: flex;
  align-items: top;
  margin-bottom: 8px;
}

.title {
  color: #1f2329;
  font-size: 26px;
  font-weight: 500;
  margin-left: 12px;
}

.sub-title {
  color: #1f2329;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.desc {
  color: #50627f;
  font-size: 16px;
  font-weight: 400;
  line-height: 170%;
}

@media screen and (max-width: 1000px) {
  .solution-item .title {
    font-size: 16px !important;
    line-height: 20px !important;
    margin-bottom: 8px !important;
  }

  .solution-item .desc {
    font-size: 14px !important;
  }

  .solution-item .sub-title {
    font-size: 14px !important;
  }

  img {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>
